import React, { useState } from "react";
import "./FAQ.css";
// import image from "../../assets/images/thumbnail.svg";
import arrowIcon from "../../assets/images/arrowOut.svg";
import arrowBack from "../../assets/images/arrowBack.svg";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import faqPDF from "../../assets/logos/UPL Genie FAQ Final 2.pdf";
import userPDF from "../../assets/logos/ChatNPP User Guide.pdf";
import Navbar from "../../components/Navbar/Navbar";
import { ThemeContext } from "../../contexts/ThemeContext";
import { useContext } from "react";
import { useTranslationContext } from "../../contexts/TranslationContext";

const videos = [
  // {
  //   title: "UPL Genie Introduction",
  //   time: "02:23",
  //   thumbnail: image,
  //   url: "https://upllimited.sharepoint.com/:v:/s/CDTCommunicationPortal/EUrf55B5pqlDos-kPfTR_wMBbh4kgE9wHHxNickCelMPDQ?e=WfuUl4",
  // },
  // {
  //   title: "UPL Genie Chat Guide",
  //   time: "01:59",
  //   thumbnail: image,
  //   url: "https://upllimited.sharepoint.com/:v:/s/CDTCommunicationPortal/EfyuwDdNuOxKl620eKQAnRcB4yMp33ToTEK2P1r1Gn8gqA?e=flLSGj",
  // },
];


const FAQ = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const navigate = useNavigate();
  const { translations } = useTranslationContext();
  // eslint-disable-next-line no-unused-vars
  const [playingIndex, setPlayingIndex] = useState(null);
  const quickReadText = translations["quick_read"] || "Quick Reads";
  // eslint-disable-next-line no-unused-vars
  const tutorialText = translations["tutorial_text"] || "Tutorial Videos";
  const backText = translations["back_text"] || "Back";
  const chatnppGuideEngText = translations["guide_text_english"] || "ChatNPP User Guide English";
  // eslint-disable-next-line no-unused-vars
  const chatnppGuideSpanishText = translations["guide_text_spanish"] || "ChatNPP User Guide Spanish";

  const handleBack = () => {
    navigate("/chat");
  };

  return (
    <>
      <div className={`home-container ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
        <Navbar />
        <ToastContainer closeButton={true} position="top-right" />
        <ToastContainer
          closeButton={true}
          autoClose={1000}
          position="top-right"
        />
        <div className="chat-container">

          <div className="video-page">
            <button className={`back-btn ${isDarkMode ? 'dark-mode' : 'light-mode'}`} onClick={handleBack}>
              <img src={arrowBack} alt="Back" className="icon-left" />
              {backText}
            </button>
            <div className={`quick-reads ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
              <span>{quickReadText}</span>
              <div className={`tags ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                <a href={userPDF} target="_blank" rel="noopener noreferrer">
                  {chatnppGuideEngText}
                  <img src={arrowIcon} alt="" className="tag-icon" />
                </a>
                {/* <a href={userPDF} target="_blank" rel="noopener noreferrer">
                  {chatnppGuideSpanishText}
                  <img src={arrowIcon} alt="" className="tag-icon" />
                </a> */}
              </div>
            </div>
            {/* <div className={`tutorial-videos ${isDarkMode ? 'dark-mode' : 'light-mode'}`}> 
               <span>{tutorialText}</span>
            </div> */}
            <div className="video-grid three-columns">
              {videos.map((video, index) => {
                return (
                  <div key={index} className="video-card-wrapper">
                    <div
                      className="video-card"
                      onClick={() => setPlayingIndex(index)}
                      style={{ cursor: "pointer" }}
                    >
                      <a
                        href={video.url}
                        target="_blank"
                        rel="noopener noreferrer">
                        <img
                          src={video.thumbnail}
                          alt={video.title}
                          className="video-thumbnail"
                        />
                        <span className="video-duration">{video.time}</span>
                      </a>
                    </div>
                    <p className={`video-title-outside ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>{video.title}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default FAQ;
